
const outsourceRoutes = [
  {
    path: '/outsource/attention',
    name: 'outsourceAttention',
    component: () => import(/* webpackChunkName: "outsourceAttention" */ '@/views/outsource/attention/index.vue'),
    meta: {
      title: "外协链",
      keepAlive: true,
    },
  },
  {
    path: '/company/about/:id',
    name: 'comaboutAbout',
    component: () => import(/* webpackChunkName: "comaboutAbout" */ '@/views/company/about/index.vue'),
    meta: {
      title: "关于我们",
      keepAlive: true,
    },
  },
  {
    path: '/company/contact/:id',
    name: 'comaboutContact',
    component: () => import(/* webpackChunkName: "comaboutContact" */ '@/views/company/contact/index.vue'),
    meta: {
      title: "联系我们",
      keepAlive: true,
    },
  },
  {
    path: '/company/home/:id',
    name: 'compHome',
    component: () => import(/* webpackChunkName: "compHome" */ '@/views/company/home/index.vue'),
    meta: {
      title: "公司首页",
    },
  },
  {
    path: '/company/lecto/:id',
    name: 'comaboutLecto',
    component: () => import(/* webpackChunkName: "comaboutLecto" */ '@/views/company/lecto/index.vue'),
    meta: {
      title: "分类选型",
      keepAlive: true,
    },
  },
];

export default outsourceRoutes;
